<template>
  <v-container class="back" fluid fill-height pa-0>
    <v-layout v-if="getSidebarActive == 'location'" column pa-0 pt-0>
      <v-flex xs12 style="position: relative" pa-0>
        <v-layout ref="barWrapper" column fill-height style="position: relative" ma-0 pt-3>
          <v-layout justify-space-between style="position: relative" ma-0 pl-3>
            <v-tabs  
              v-model="panel"
              height="40px"
              class="font-weight-normal"        
              left
            >
              <v-tabs-slider color="white" style="height: 0px; max-width: 0px;">
              </v-tabs-slider>
              <v-tab
                  class="font-weight-normal"  
                  v-for="(place, index) in getPlaces"
                  :key="index"
                  :data-testid="$options.name + '__' + place + '_tab__' + 'toolbar'"
                >
                <template slot="default">
                  <div class="tab_wrapper">
                    <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'">
                      {{ $t(place) }} 
                    </div>
                  </div>
                </template>
              </v-tab>
            </v-tabs>

            <v-flex shrink >
              <v-layout v-if="checkPage('physical')" fill-height justify-space-around align-center px-2>
                <v-tooltip bottom color="secondary">
                  <v-btn icon flat v-if="$store.state.auth.user.level <= 1" 
                    :data-testid="$options.name + '__btn__' + 'onLocationCreate'" 
                    @click="() => onLocationCreate()"
                    dark medium class="lighten-2 font-weight-medium" slot="activator" >
                    <svg-icon
                      :color="'primary'"
                      :name="'add'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('create new') }}</span>
                </v-tooltip>
  
                <v-tooltip bottom color="secondary">
                  <v-btn icon flat v-if="$store.state.auth.user.level <= 1" 
                    :data-testid="$options.name + '__btn__' + 'onLocationEdit'" 
                    @click="() => onLocationEdit()" 
                    dark medium class="lighten-2 font-weight-medium" slot="activator" >
                    <svg-icon
                      :color="'primary'"
                      :name="'edit'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('change') }}</span>
                </v-tooltip>
              </v-layout>
            </v-flex>
          </v-layout>
            <scroll-area>
              <template slot="body">
                  <v-layout v-for="(place, i) in getPlaces" :key="i" v-if="getPlaces[panel] == place" fill-height px-2 pt-2 ma-0>
                    <v-layout column fill-height v-if="place == 'main' && getFields" :data-testid="$options.name + '__v-layout_place_readonly__' + place"  justify-start px-2>                       
                      <v-layout shrink @click.stop="showMain = !showMain" justify-space-between px-1 mx-1>
                        <v-layout shrink justify-start align-center>
                          <span class="uppercase">
                            {{ $t('main') }}
                          </span>
                        </v-layout>
                        <v-btn 
                        :data-testid="$options.name + '__btn__' + 'place == main'" 
                        @click.stop="showMain = !showMain" flat x-small dark class="white" slot="activator">
                          <v-icon v-if="!showMain" color="accent">expand_less</v-icon>
                          <v-icon v-if="showMain" color="accent">expand_more</v-icon>
                        </v-btn>
                      </v-layout>

                      <v-layout v-show="showMain" shrink v-for="(field, index) in getFields" :key="[place] + field.name" v-if="field.value && field.show == 'true' && field.place == place && field.name != 'coordinates'" px-2>
                        <v-flex xs4 v-if="field.value && field.place == place && field.name != 'coordinates'" shrink px-0 pb-2>                           
                          <v-text-field
                            :value="$t(field.name)"
                            :data-testid="$options.name + '__v-text-field_name_readonly__' + field.name" 
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            persistent-hint
                            hide-details
                            color="white"
                          >                          
                          </v-text-field>
                        </v-flex>

                        <v-flex xs8 v-if="field.value && field.place == place && field.name != 'coordinates'" shrink px-0 pb-2>                            
                          <v-text-field
                            :value="field.name == 'type' || field.name == 'condition_type' || field.name == 'location_type'? $t(field.value) : field.value"
                            :data-testid="$options.name + '__v-text-field_name_readonly__' + field.value" 
                            light
                            auto-grow
                            outline
                            readonly
                            class="white"
                            persistent-hint
                            hide-details
                            color="backgrey"
                          >                            
                          </v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout shrink @click.stop="showFiles = !showFiles" justify-space-between px-1 mx-1>
                        <v-layout shrink justify-start align-center>
                          <span class="uppercase">
                            {{ $t('attached files') }}
                          </span>
                        </v-layout>
                        <v-btn 
                        :data-testid="$options.name + '__btn__' + 'attached files'" 
                        @click.stop="showFiles = !showFiles" flat x-small dark class="white" slot="activator">
                          <v-icon v-if="!showFiles" color="accent">expand_less</v-icon>
                          <v-icon v-if="showFiles" color="accent">expand_more</v-icon>
                        </v-btn>
                      </v-layout>

                      <v-flex xs12 v-show="showFiles">
                        <file-list
                          :files="getFiles"
                          :data="getData"
                          @upload="(payload) => onFileAdd(payload)"
                          @edit="onFileEdit"
                          @delete="(payload) => onFileDelete(payload)"
                        />
                      </v-flex>

                      <v-layout shrink @click.stop="showStat = !showStat" justify-space-between px-1 mx-1>
                        <v-layout shrink justify-start align-center>
                          <span class="uppercase">
                            {{ $t('statistics') }}
                          </span>
                        </v-layout>
                        <v-btn 
                        :data-testid="$options.name + '__btn__' + 'statistics'" 
                        @click.stop="showStat = !showStat" flat x-small dark class="white" slot="activator">
                          <v-icon v-if="!showStat" color="accent">expand_less</v-icon>
                          <v-icon v-if="showStat" color="accent">expand_more</v-icon>
                        </v-btn>
                      </v-layout>

                      <v-layout column v-show="showStat" fill-height justify-start>
                        <location-statistics
                          @select=""
                        />
                      </v-layout>

                      <v-layout shrink v-if="area == 'map'" @click.stop="showMap = !showMap" justify-space-between px-1 mx-1>
                        <v-layout shrink justify-start align-center>
                          <span class="uppercase">
                            {{$t('GEO binding')}}
                          </span>
                        </v-layout>
                        <v-btn 
                        :data-testid="$options.name + '__btn__' + 'statistics'" 
                        @click.stop="showMap = !showMap" flat x-small dark class="white" slot="activator">
                          <v-icon v-if="!showMap" color="accent">expand_less</v-icon>
                          <v-icon v-if="showMap" color="accent">expand_more</v-icon>
                        </v-btn>
                      </v-layout>

                      <v-layout v-if="area == 'map' && showMap" column fill-height justify-start>
                          <component
                            v-if="showMap"
                            is="location-map"
                            :data="getData"
                            :editMapCenter="false"
                          />
                      </v-layout>

                    </v-layout>

                    <v-layout fill-height v-if="place == 'composition'" :data-testid="$options.name + '__v-layout_place_readonly__' + place" justify-start>
                      <equipment-table
                        :data="getData"
                        :devices="devices"
                        @select="(payload) => onDeviceSelect(payload)"
                      />
                    </v-layout>

                    <v-layout column fill-height v-if="place == 'map/documents' && getData && !(getData.coordinates || getData.latitude)" :data-testid="$options.name + '__v-layout_place_readonly__' + place" justify-start>
                      <file-list
                        :files="getFiles"
                        :data="getData"
                        @upload="(payload) => onFileAdd(payload)"
                        @edit="onFileEdit"
                        @delete="(payload) => onFileDelete(payload)"
                      />
                    </v-layout>
                    
                    <v-layout column fill-height v-if="place == 'services'" :data-testid="$options.name + '__v-layout_place_readonly__' + place" justify-start>
                      <v-tabs 
                        v-model="connectionsPanel"
                        height="40px"
                        left
                      >
                        <v-tabs-slider color="primary" style="height: 0px; max-width: 0px"></v-tabs-slider>
                        <v-tab
                          class="font-weight-normal "        
                          v-for="(tab, index) in getConnectionPlaces"
                          :key="index"
                          :data-testid="$options.name + '__' + tab + '_tab__' + 'services'"
                        >
                            <template slot="default">
                              <div class="tab_wrapper">
                                <div :class="getConnectionPlaces[connectionsPanel] == tab ? 'tab__border' : 'custom-tab'">
                                  {{ $t(tab) }} 
                                </div>
                              </div>
                            </template>
                        </v-tab>
                      </v-tabs>
                      <v-layout column fill-height justify-start pt-2>
                        <connections
                          v-if="getConnectionPlaces[connectionsPanel] == 'connections'"
                          :data="getData"
                        />
                        <channels
                          v-if="getConnectionPlaces[connectionsPanel] == 'channels'"
                          :data="getData"
                        />
                      </v-layout>
                    </v-layout>

                    <v-layout column fill-height v-if="place == 'connections'" :data-testid="$options.name + '__v-layout_place_readonly__' + place" justify-start>
                      <location-connections
                        :data="getData"
                        :devices="getDevices"
                        @select=""
                      />
                    </v-layout>

                    <v-layout column fill-height v-if="place == 'graph'" id="g_location_container_wrapper" style="position: inherit; overflow: hidden" :data-testid="$options.name + '__v-layout_place_readonly__' + place" justify-start>
                      <l-graph
                        :data="getData"
                        :devices="getDevices"
                        :visConnections="getConnections"
                        @select=""
                      />
                    </v-layout>
                  </v-layout>

              </template>
            </scroll-area>

          <update-location-bar
            v-if="checkPage('physical')"
            :open="getLocationBarUpdate"
            :data="getData"
            :files="files"
            :mapType="'OL'"
            @upload="(payload) => onFileAdd(payload)"
            @update="updateTree"
            @close="() => onLocationEditClose()"
          />

          <create-location-bar
            v-if="checkPage('physical')"
            :open="getLocationBarCreate"
            :data="getData"
            @update="updateTree"
            @close="() => onLocationCreateClose()"
          />

          <device-bar
            v-if="checkPage('physical') && getDeviceBarOpen"
            :open="getDeviceBarOpen"
            @update="(payload) => updateDevice(payload)"
            @load-devices="loadDevices"
            @close="() => onDeviceBarClose()"
          />

        </v-layout>

      </v-flex>

    </v-layout>

    <v-dialog v-model="dialog.upload.show" max-width="50%" v-if="dialog.upload.show && getSidebarActive == 'location'">
      <form-file-import
        :newFiles="dialog.upload.files"
        :edit="filesEdit"
        :files="filesEdit ? getFiles : []"
        :activeObj="getData"
        @update="updateTree"
        @close="onFileImportClose()"
        @delete="(payload) => onFileDelete(payload)"
      />
    </v-dialog>

    <v-layout v-if="getSidebarActive == 'device'"  column pa-0 pt-0>
      <v-flex xs12 style="position: relative" pa-0>
        <v-layout ref="barWrapper" column fill-height style="position: relative" ma-0>
          <device-bar
            :open="true"
            :sizeButton="false"
            noclose
            @update="(payload) => updateDevice(payload)"
            @load-devices="loadDevices"
          />
        </v-layout>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import UpdateLocationBar from '@/nms/pages/location/update-location-bar.vue'
import CreateLocationBar from '@/nms/pages/location/create-location-bar.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'
import fileList from '@/nms/components/partials/file-list.vue'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import EquipmentTable from '@/nms/pages/location/table/equipment-table.vue'
import LocationMap from '@/nms/components/map/map.vue'
import LocationStatistics from '@/nms/pages/location/table/location-statistics.vue'
import LocationConnections from '@/nms/pages/location/table/location-connections.vue'
import Connections from '@/nms/pages/services/connections.vue'
import Channels from '@/nms/pages/services/channels.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import LGraph from '@/nms/pages/topology/g-location.vue'
import { mapGetters } from 'vuex'

// Типы
interface DeviceItem {
  $id?: string
  id?: string
  name?: string
  cls?: string
  _cmdb_?: boolean
  tree_view?: boolean
  children?: DeviceItem[]
  getLinks?: (options?: any) => Promise<DeviceItem[]>
  getParent?: () => Promise<DeviceItem>
  [key: string]: any
}

interface ModelData {
  fields: Record<string, any>
  items: Record<string, any>
  obj: Record<string, any>
}

interface BarState {
  location: {
    create: { open: boolean }
    update: { open: boolean }
  }
  device: { open: boolean }
}

interface DialogState {
  create: { show: boolean; files: any[] }
  update: { show: boolean; files: any[] }
  upload: { show: boolean; files: any[] }
}

interface LocationData {
  $id?: string
  [key: string]: any
}

interface FileItem {
  id?: string
  data?: {
    description?: string
  }
  [key: string]: any
}

interface ActiveDevice {
  $id?: string
  [key: string]: any
}

interface DabLockResponse {
  ok?: boolean
  [key: string]: any
}

export default Vue.extend({
  name: 'LOCATION',

  components: {
    scrollArea,
    UpdateLocationBar,
    CreateLocationBar,
    DeviceBar,
    fileList,
    FormFileImport,
    EquipmentTable,
    LocationMap,
    LocationStatistics,
    LocationConnections,
    Connections,
    Channels,
    svgIcon,
    LGraph
  },

  props: {},

  data(): {
    showMain: boolean
    showFiles: boolean
    showStat: boolean
    showMap: boolean
    area: string
    panel: number
    connectionPlaces: string[]
    connectionsPanel: number
    location: Record<string, any>
    devices: DeviceItem[]
    crumbs: any[]
    meta: Record<string, any>
    obj: DeviceItem | null
    model: ModelData
    bar: BarState
    files: FileItem[]
    filesEdit: boolean
    dialog: DialogState
  } {
    return {
      showMain: true,
      showFiles: false,
      showStat: false,
      showMap: false,
      panel: 0,
      connectionPlaces: ['connections', 'channels'],
      connectionsPanel: 0,
      location: {},
      devices: [],
      crumbs: [],
      meta: {},
      obj: null,
      model: {
        fields: {},
        items: {},
        obj: {},
      },
      bar: {
        location: {
          create: { open: false },
          update: { open: false },
        },
        device: { open: false },
      },
      area: 'plan',
      files: [],
      filesEdit: false,
      dialog: {
        create: { show: false, files: [] },
        update: { show: false, files: [] },
        upload: { show: false, files: [] },
      },
    }
  },

  computed: {
    getSidebarActive(): string | null {
      return this.$store.state.devices.sidebar.active
    },

    getData(): DeviceItem | undefined {
      return this.$store.state.devices.treeActive[0]
    },

    getLocationBarUpdate(): boolean {
      return this.bar.location.update.open
    },

    getLocationBarCreate(): boolean {
      return this.bar.location.create.open
    },

    getDeviceBarOpen(): boolean {
      const dev = this.$store.state.devices.activeDevice as ActiveDevice | null
      this.bar.device.open = !!(dev && dev.$id)
      return this.bar.device.open
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getDevices(): DeviceItem[] {
      return this.devices
    },

    getConnections(): any[] {
      return this.$store.getters.getConnections
    },

    getConnectionPlaces(): string[] {
      return this.connectionPlaces
    },

    getPlaces(): string[] {
      if (!this.checkPage('physical')) return []
      
      const places = this.$store.getters.getUI.events_journal 
        ? this.$store.getters.getPlaces.show.location 
        : this.$store.getters.getPlaces.show.location.filter((place: string) => place !== 'events')
      
      if (this.$store.state.auth.user?.level === 0) {
        return places
      } else {
        return places.filter((place: string) => place !== 'settings')
      }
    },

    getFiles(): FileItem[] {
      return this.files.filter(file => {
        return file.data?.description ? file.data.description.split('.').shift() !== 'image_$' : true
      })
    },

    ...mapGetters(['checkPage']),
  },

  watch: {
    '$store.state.devices.activeDevice': {
      handler(newVal: ActiveDevice | null): void {
        if (!newVal) {
          this.bar.device.open = false
          return
        }
        this.bar.device.open = true
      },
      deep: true
    },

    getData: {
      handler(): void {
        if (!this.getData) return
        this.bar.location.update.open = false
        this.setup('WATCH GETDATA')
      },
      deep: true
    },

    '$store.state.file.upload.counter': {
      handler(): void {
        this.loadFiles()
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  methods: {
    async setup(caller: string): Promise<void> {
      console.log(this.$options.name, 'setup', 'caller', caller)
      if (!this.getData) return
      this.area = 'plan'
      this.showStat = false
      this.showMap = false
      this.loadDevices()
      this.loadMeta()
      this.loadFiles()
    },

    async loadDevices(): Promise<void> {
      try {
        this.setLoader('loadDevices', true)
        
        if (this.$store.state.devices.treeActive[0]?._cmdb_) {
          this.obj = this.$store.state.devices.treeActive[0]
        } else {
          this.obj = await this.$bridge.getObjectById(this.$store.state.devices.treeActive[0]?.$id)
        }

        if (!this.obj) {
          this.setLoader('loadDevices', false)
          return
        }
        
        console.log(this.$options.name, 'loadDevices', 'this.obj', this.obj)
        const data$ = await this.obj.getLinks?.({ compute: 'is_used' })
        this.devices = []
        
        if (data$?.length) {
          data$.forEach((child: DeviceItem) => {
            if (child.cls === 'device') {
              this.devices.push(child)
            }
          })
        }
        this.setLoader('loadDevices', false)
      } catch (error) {
        console.error('CATCH', this.$options.name, 'loadDevices', error)
        this.setLoader('loadDevices', false)
      }
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        this.setLoader('loadMeta', true)
        this.meta = await this.$loadMeta(this.getData, false, this.$options.name)
        
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          this.prepareData()
        }
        this.setLoader('loadMeta', false)
      } catch (error) {
        console.error('CATCH', this.$options.name, 'loadMeta', error)
        this.setLoader('loadMeta', false)
      }
    },

    async prepareData(): Promise<void> {
      try {
        this.setLoader('prepareData', true)
        const model = await this.$prepareData(this.model, this.getData, this.meta, this.$options.name)
        
        if (model) {
          console.log(this.$options.name, 'prepareData', 'model', model)
          this.model = model
        }
        if(this.model.fields.coordinates?.show == 'true') {
          this.area = 'map'
        }
        this.setLoader('prepareData', false)
      } catch (error) {
        console.error('CATCH', this.$options.name, 'prepareData', error)
        this.setLoader('prepareData', false)
      }
    },

    async loadFiles(): Promise<void> {
      try {
        this.setLoader('loadFiles', true)
        this.files = await this.$loadFiles(this.getData?.$id)
        this.setLoader('loadFiles', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    async updateTree(): Promise<void> {
      try {
        console.log(this.$options.name, 'UPDATE_TREE')
        this.setLoader('updateTree', true)
        
        const obj$ = this.getData?._cmdb_ 
          ? this.getData 
          : await this.$bridge.getObjectById(this.getData?.$id)
        
        console.log(this.$options.name, 'UPDATE_TREE obj$', obj$)
        
        if (obj$) {
          if (obj$.cls === 'device' && obj$.tree_view) {
            console.log(this.$options.name, 'UPDATE_TREE', 'device no show')
            const parent = await obj$.getParent?.()
            if (parent) {
              this.$store.dispatch('loadChildren', parent)
              this.$store.dispatch('activeTree', parent)
            } else {
              this.$store.dispatch('activeTree', obj$)
            }
          } else if (obj$.cls === 'folder') {
            await this.$store.dispatch('loadTree')
            console.log(this.$options.name, 'UPDATE_TREE obj$', obj$)
          } else {
            this.$store.dispatch('loadChildren', obj$)
            console.log(this.$options.name, 'UPDATE_TREE obj$', obj$)
          }
        }
        
        this.$set(this.bar.location.create, 'open', false)
        this.$set(this.bar.location.update, 'open', false)
        this.setLoader('updateTree', false)
        await this.$store.dispatch('disposeDabLock', this.getData?.$id)
        this.$store.dispatch('setEditMode', false)
      } catch (err) {
        this.$errorHandler(err)
        console.error('CATCH', this.$options.name, 'updateTree', 'smth wrong', err)
        this.setLoader('updateTree', false)
        await this.$store.dispatch('disposeDabLock', this.getData?.$id)
        this.$store.dispatch('setEditMode', false)
      }
    },

    async updateDevice(payload: DeviceItem): Promise<void> {
      try {
        await this.$store.dispatch('activeDevice', payload)
        this.updateTree()
        this.$set(this.bar.location.create, 'open', false)
        this.$set(this.bar.location.update, 'open', false)
        await this.$store.dispatch('disposeDabLock', this.getData?.$id)
      } catch (err) {
        this.$errorHandler(err)
        console.error('CATCH', this.$options.name, 'updateDevice', 'smth wrong', err)
      }
    },

    async onDeviceSelect(payload: string | DeviceItem): Promise<void> {
      try {
        console.log(this.$options.name, 'onDeviceSelect', payload)
        const id = typeof payload === 'string' ? payload : payload.$id
        const device$ = await this.$bridge.getObjectById(id)
        console.log(this.$options.name, 'onDeviceSelect', 'device$', device$)
        device$.children = await device$.getLinks?.({ compute: 'is_used' })
        this.$store.dispatch('activeDevice', device$)
      } catch (err) {
        this.$errorHandler(err)
        console.error('CATCH', this.$options.name, 'onDeviceSelect', 'smth wrong', err)
      }
    },

    onFileAdd(payload: any): void {
      Object.keys(payload).forEach(index => {
        this.dialog.upload.files.push(payload[index])
      })
      this.$set(this.dialog.upload, 'show', true)
    },

    onLocationCreate(): void {
      this.$set(this.bar.location.create, 'open', !this.bar.location.create.open)
      this.$set(this.bar.location.update, 'open', false)
      this.$store.dispatch('setEditMode', true)
    },

    onLocationCreateClose(): void {
      this.$set(this.bar.location.create, 'open', false)
      this.$store.dispatch('setEditMode', false)
    },

    async onLocationEdit(): Promise<void> {
      try {
        const block = await this.$store.dispatch('createDabLock', this.getData?.$id) as DabLockResponse
        if (block?.ok) {
          this.$set(this.bar.location.update, 'open', !this.bar.location.update.open)
          this.$set(this.bar.location.create, 'open', false)
          this.$store.dispatch('setEditMode', true)
        } else {
          this.$errorHandler(block, 'DabLock')
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'onLocationEdit', err)
      }
    },

    async onLocationEditClose(): Promise<void> {
      await this.$store.dispatch('disposeDabLock', this.getData?.$id)
      this.$set(this.bar.location.update, 'open', false)
      this.$store.dispatch('setEditMode', false)
    },

    async onDeviceBarClose(): Promise<void> {
      this.$store.dispatch('activeDevice', null)
      this.$store.dispatch('setEditMode', false)
    },

    onFileEdit(): void {
      if (!this.files.length) return
      this.filesEdit = true
      this.$set(this.dialog.upload, 'show', true)
    },

    onFileDelete(id: string): void {
      this.dialog.upload.files.forEach((file, index) => {
        if (file.id === id) {
          this.dialog.upload.files.splice(index, 1)
        }
      })
      this.$bridge.deleteDocument(id)
      this.loadFiles()
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    onFileImportClose(): void {
      this.$set(this.dialog.upload, 'show', false)
      this.$set(this.dialog.upload, 'files', [])
      this.filesEdit = false
    },
  },
})
</script>

<style >

.crumbs {
  color: black;
}

.crumbs:hover {
  color: red;
  cursor: pointer;
}

.create-location {
  background-color: transparent;
}

.create-location:hover {
    color: red;
    cursor: pointer;
}

/* .v-tabs__item {
  padding: 4px 2px !important;
  border-bottom: solid 1px #DCDCDC !important;
}

.tabs__border {
  border-bottom: solid 1px #DCDCDC !important;
}

.tab__border {
    font-size: 16px !important;
    border-left: solid 1px #DCDCDC !important;
    border-right: solid 1px #DCDCDC !important;
    border-top: solid 10px #CDEBF9 !important;
    border-bottom: solid 1px #FFFFFF !important;
    padding: 2px 12px 12px 12px;
    cursor: pointer;
}

.custom-tab {
  font-size: 16px !important;
  height: 40px;
  border-left: solid 1px #DCDCDC !important;
  border-right: solid 1px #DCDCDC !important;
  border-top: solid 1px #DCDCDC !important;
  border-bottom: solid 1px #DCDCDC !important;
  padding: 11px 12px 12px 12px;
  cursor: pointer;
} */
/* .custom-tab {
  height: 40px;
  border-left: solid 1px #DCDCDC !important;
  border-right: solid 1px #DCDCDC !important;
  border-top: solid 1px #DCDCDC !important;
  border-bottom: solid 8px #FFFFFF !important;
  padding: 11px 12px 12px 12px;
  cursor: pointer;
} */

</style>
